import { useState } from 'react'

export const CLIENT_NAV_ITEMS = [
  { key: 'overview', label: 'Overview', standalone: true },
  {
    section: 'DISCOVER',
    items: [
      { key: 'regulatory-parent', label: 'Reg & Compliance', icon: 'M12 3v18m0-18l-6 2l-3 9a5.002 5.002 0 006.001 0L6 5M12 3l6 2l3 9a5.002 5.002 0 01-6.001 0L18 5M8 21h8', children: [
        { key: 'reg-guidance', label: 'Regulatory Guidance' },
        { key: 'reg-compliance', label: 'Compliance Insights' },
        { key: 'reg-updates', label: 'Regulatory Updates' },
      ]},
      { key: 'tech-parent', label: 'Technology', icon: 'M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01', children: [
        { key: 'tech-assets', label: 'Assets' },
        { key: 'tech-stack', label: 'Security Tooling' },
        { key: 'control-testing', label: 'Control Testing' },
        { key: 'control-integrations', label: 'Integrations', comingSoon: true },
      ]},
    ]
  },
  {
    section: 'GOVERN',
    items: [
      { key: 'plan-overview', label: 'Plan Overview', icon: 'M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7' },
      // Lightweight GRC: pick frameworks (NIST CSF 2.0, CIS CSC, HIPAA, PCI DSS,
      // ISO 27001, SOC 2, NIST 800-53/171/CMMC) and crosswalk to assessment
      // controls. Built in a later phase.
      { key: 'frameworks', label: 'Frameworks', comingSoon: true, icon: 'M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6' },
      { key: 'enablement', label: 'Enablement Plan', comingSoon: true, icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01' },
      // Risk Management — parent group for all risk-surfacing items. Vendor
      // risks, audit findings, and (eventually) pen test findings all roll
      // up into Risk Register, so they live together.
      { key: 'risk-management-parent', label: 'Risk Management', icon: 'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z', children: [
        { key: 'risk-register', label: 'Risk Register', comingSoon: true },
        { key: 'third-party-risk', label: 'Third-Party Risk', comingSoon: true },
        { key: 'audit-findings', label: 'Audit Findings', comingSoon: true },
      ]},
      // Documentation — parent group for the document repositories.
      { key: 'documentation-parent', label: 'Documentation', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z', children: [
        { key: 'policies', label: 'Policies' },
        { key: 'documents', label: 'Document Vault' },
      ]},
      // Consolidated hub for client-facing exports (Executive Advisory,
      // Insurance Review, Risk Appetite Statement, POA&M / Enablement Plan,
      // etc.). Replaces the prior standalone Executive Report entry.
      { key: 'advisory-reports', label: 'Advisory Reports', comingSoon: true, icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
      { key: 'enablement-config', label: 'Configuration', comingSoon: true, icon: 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4' },
    ]
  },
  {
    section: 'MANAGE',
    items: [
      { key: 'admin-portal', label: 'Portal Settings', iconPaths: ['M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z', 'M15 12a3 3 0 11-6 0 3 3 0 016 0z'] },
      { key: 'admin-users', label: 'Users & Access', icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
      { key: 'admin-activity', label: 'Activity Feed', icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' },
    ]
  },
]

function isParentActive(item, activeKey) {
  if (item.key === activeKey) return true
  return item.children?.some(c => c.key === activeKey) || false
}

function ClientVerticalNav({ activeKey, onNavigate, collapsed, onToggleCollapse }) {
  const [collapsedSections, setCollapsedSections] = useState({})

  const toggleSection = (key) => {
    setCollapsedSections(prev => ({ ...prev, [key]: !prev[key] }))
  }

  return (
    <div>
      <nav className="rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-sm">
          <div className="pb-3">
          {/* Toggle inside nav header */}
          <div className="flex items-center justify-between px-4 pt-3 pb-1">
            <span className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">Navigation</span>
            <button
              onClick={onToggleCollapse}
              className="flex items-center justify-center w-7 h-7 rounded-md text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
              title="Hide navigation"
            >
              <svg className="w-[18px] h-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
              </svg>
            </button>
          </div>
          {CLIENT_NAV_ITEMS.map((group, gi) => {
            if (group.standalone) {
              const isActive = activeKey === group.key
              return (
                <div key={group.key} className="px-3 py-1">
                  <button
                    onClick={() => onNavigate(group.key)}
                    className={`
                      w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-[13px] font-medium transition-colors relative
                      ${isActive
                        ? 'text-gray-900 dark:text-white bg-gray-100 dark:bg-gray-800'
                        : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800/50'
                      }
                    `}
                  >
                    <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                    {group.label}
                    {isActive && (
                      <span className="absolute right-2 w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#8AD0D6' }} />
                    )}
                  </button>
                </div>
              )
            }

            return (
              <div key={gi} className={gi > 0 ? 'mt-1' : ''}>
                {/* Section label */}
                <div className="px-6 pt-4 pb-1.5">
                  <span className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500">
                    {group.section}
                  </span>
                </div>

                {/* Items */}
                {group.items.map(item => {
                  const parentActive = isParentActive(item, activeKey)
                  const directActive = item.key === activeKey

                  if (item.comingSoon) {
                    return (
                      <div key={item.key} className="px-3">
                        <div className="flex items-center gap-2.5 px-3 py-1.5 text-[13px] text-gray-400 dark:text-gray-600 cursor-default">
                          {(item.icon || item.iconPaths) && (
                            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              {item.iconPaths ? item.iconPaths.map((d, i) => (
                                <path key={i} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={d} />
                              )) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={item.icon} />
                              )}
                            </svg>
                          )}
                          {item.label}
                          <span className="text-[9px] font-medium px-1.5 py-px rounded bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-600 ml-auto">
                            Soon
                          </span>
                        </div>
                      </div>
                    )
                  }

                  return (
                    <div key={item.key} className="px-3">
                      {/* Item — toggles children visibility if has children, navigates if no children */}
                      <button
                        onClick={() => item.children ? toggleSection(item.key) : onNavigate(item.key)}
                        className={`
                          w-full flex items-center justify-between px-3 py-1.5 rounded-lg text-[13px] transition-colors relative
                          ${directActive && !item.children
                            ? 'text-gray-900 dark:text-white bg-gray-100 dark:bg-gray-800 font-medium'
                            : parentActive
                            ? 'text-gray-900 dark:text-white font-medium'
                            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-50 dark:hover:bg-gray-800/50'
                          }
                        `}
                      >
                        <span className="flex items-center gap-2.5">
                          {(item.icon || item.iconPaths) && (
                            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              {item.iconPaths ? item.iconPaths.map((d, i) => (
                                <path key={i} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={d} />
                              )) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={item.icon} />
                              )}
                            </svg>
                          )}
                          {item.label}
                        </span>
                        {item.children && (
                          <svg className={`w-3.5 h-3.5 text-gray-400 transition-transform duration-150 ${collapsedSections[item.key] ? '-rotate-90' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        )}
                        {directActive && !item.children && (
                          <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: '#8AD0D6' }} />
                        )}
                      </button>

                      {/* Children — collapsible */}
                      {item.children && !collapsedSections[item.key] && item.children.map(child => {
                        const childActive = child.key === activeKey
                        if (child.comingSoon) {
                          return (
                            <div
                              key={child.key}
                              className="flex items-center gap-1.5 pl-6 pr-3 py-1 text-xs text-gray-400 dark:text-gray-600 cursor-default"
                            >
                              {child.label}
                              <span className="text-[9px] font-medium px-1.5 py-px rounded bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-600">
                                Soon
                              </span>
                            </div>
                          )
                        }
                        return (
                          <button
                            key={child.key}
                            onClick={() => onNavigate(child.key)}
                            className={`
                              w-full text-left pl-6 pr-3 py-1 rounded-md text-xs transition-colors relative
                              ${childActive
                                ? 'text-gray-900 dark:text-white font-medium bg-gray-100 dark:bg-gray-800'
                                : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800/50'
                              }
                            `}
                          >
                            {child.label}
                            {childActive && (
                              <span className="absolute right-2 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full" style={{ backgroundColor: '#8AD0D6' }} />
                            )}
                          </button>
                        )
                      })}
                    </div>
                  )
                })}
              </div>
            )
          })}
          </div>
      </nav>
    </div>
  )
}

export default ClientVerticalNav
